module.exports = __webpack_public_path__ + "img/resource-tech-image-38.feac5099.jpg";